import React from 'react'
import propTypes from 'prop-types'

export const ContextComposer = ({providers, children}) =>
  providers.reduceRight(
    (children, parent, index) => React.cloneElement(parent, { children }), children
  )

ContextComposer.propTypes = {
  providers: propTypes.arrayOf(
    propTypes.element,
  ).isRequired,
  children: propTypes.node.isRequired,
}
